<template>
  <figure :id="entry._id" ref="entryElementRef" class="relative" @mouseover="hoverImage" @mouseleave="hoverImage(false)">
    <!-- image slider -->
    <OButton
      pure
      class="absolute z-1 u-center right-4 top-4 bg-black hover:bg-o-blue h-10 w-10 sm:h-12 sm:w-12 rounded-full"
      :class="{ 'left-3': entry.metadata.fittoscreen === false }"
      @click="handleEntryImageSlider"
    >
      <OIcon icon="fullscreen" :width="isMobile ? '21px' : '24px'" :height="isMobile ? '21px' : '24px'" />
    </OButton>
    <!-- fragment gelince burdaki logic spoiler wrapper icinde yapilabilir -->
    <div v-if="hasSpoiler" class="image">
      <SpoilerWrapper>
        <EntryImage v-if="entry.image" :entry="entry" />
      </SpoilerWrapper>
    </div>
    <div v-else-if="entry.metadata.fittoscreen === false">
      <EntryImage :entry="entry" show-original />
    </div>
    <div v-else-if="hasList && entry.image && entry.metadata.extraImages.length" class="flex w-full image">
      <div class="multi-image relative overflow-hidden">
        <EntryImage :entry="entry" />
      </div>
      <div class="multi-image relative overflow-hidden">
        <EntryImage :entry="entry" use-extra />
      </div>
    </div>
    <div v-else-if="entry.image" class="image relative">
      <EntryImage :entry="entry" />
    </div>
    <OLink
      v-if="!hidesource && source"
      class="text-gray-500 italic text-xs"
      rel="noopener noreferrer nofollow"
      target="_blank"
      :href="source"
    >
      {{ sourceText }}
    </OLink>

    <!-- <pre v-if="!entry.image" class="whitespace-pre-wrap text-xs border-red-500 border">{{ entry }}</pre> -->
    <!--  eslint-disable-next-line vue/no-v-html -->
    <figcaption v-if="entry.text.html" v-html="entry.text.html"></figcaption>
    <EntryHoverMenu v-if="!isMobile && showMenu" :entry="entry" />
  </figure>
</template>

<script>
import { computed, defineComponent, ref, inject, useContext } from '@nuxtjs/composition-api';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import ArticleAuthor from './ArticleAuthor.vue';
import EntryImage from './EntryImage';
import SpoilerWrapper from './SpoilerWrapper';
import EntryHoverMenu from '~/modules/article/components/EntryHoverMenu';
import { useDevice } from '~/composables/useDevice';
import { useModal } from '~/composables/useModal';
import { OButton, OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    EntryHoverMenu,
    SpoilerWrapper,
    ArticleAuthor,
    EntryImage,
    OButton,
    OLink,
    OIcon,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const { openModal } = useModal();
    const { $analyticsEvent } = useContext();
    const hasSpoiler = computed(() => props.entry?.metadata?.image_clickreveal || false);
    const hasList = computed(() => props.entry.metadata?.extra_media === 'list');
    const showMenu = ref(false);
    const hoverImage = (state = true) => {
      showMenu.value = state;
    };
    const hidesource = computed(() => props.entry.metadata?.hidesource || props.entry.metadata?.extra_media === 'compare');
    const source = computed(() => props.entry.urls.source);
    const sourceText = computed(() => {
      const url = new URL(props.entry.urls.source);
      return url.hostname;
    });

    const { entries, route, title, categories } = inject('article');
    const isTestArticle = categories.some((category) => category.name === 'Test');
    const handleEntryImageSlider = () => {
      // add a new dublicated state for closing the modal on the browser back
      history.pushState(null, null, document.URL);
      openModal(import('~/modules/article/components/slider/EntryImageSlider' /* webpackChunkName: "EntryImageSlider" */), {
        id: props.entry?.image?._id,
        entries,
        route,
        title,
        isTestArticle,
      });
      $analyticsEvent('User', 'User_Engagement', 'gallerymode-open');
    };

    // Event Click Handlers For Analytics
    const entryElementRef = ref();
    const { initiliazeEntryEvents } = useTracking();
    initiliazeEntryEvents(entryElementRef);

    return { hasSpoiler, isMobile, showMenu, hoverImage, hidesource, source, sourceText, entryElementRef, hasList, handleEntryImageSlider };
  },
});
</script>
<style lang="scss">
.article .entry--image {
  .multi-image {
    width: calc(50% - 2.5px);
    &:first-child {
      margin-right: 2.5px;
    }
    &:last-child {
      margin-left: 2.5px;
    }
  }
  figure figcaption {
    margin-top: 16px;
    blockquote {
      quotes: none;
      border-left: 3px solid #ddd;
      padding-left: 10px;
      margin-left: 10px;
    }
  }
}
</style>
